<div class="applications-section">
  <div class="section-header">
    <h3 class="applications-title">Applications</h3>
    @if (permissionService.can_write_service_config$ | async) {
    <div>
      <button nxButton="secondary small" type="button" class="create-app-btn"
        (click)="onCreateApplication(); $event.stopPropagation()" title="Add Application">
        Add Application
      </button>
    </div>
    }
  </div>

  @if (!isApplicationsLoading) {
  @if (applications.length > 0) {
  <div class="applications-list">
    <table nxTable>
      <thead>
        <tr nxTableRow>
          <th nxHeaderCell class="collapse-column"></th>
          <th nxHeaderCell>Application Name</th>
          <th nxHeaderCell>Contact Email</th>
          <th nxHeaderCell>Email Distributions</th>
          <th nxHeaderCell>Features</th>
          @if (permissionService.can_write_service_config$ | async) {
          <th nxHeaderCell class="actions-column">Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (application of applications; track application) {
        <tr nxTableRow class="application-row over-effect"
          [class.selected-row]="selectedApplicationId === application.applicationId"
          (click)="onApplicationSelect(application); $event.stopPropagation()">
          <td nxTableCell class="collapse-column">
            <span class="collapse-icon" [class.expanded]="selectedApplicationId === application.applicationId">
              ▶
            </span>
          </td>
          <td nxTableCell>{{ application.applicationName }}</td>
          <td nxTableCell>{{ application.contactEmail }}</td>
          <td nxTableCell class="td-sm">
            <div class="chip-wrapper">
              @if (application.emailDistributions && application.emailDistributions.length > 1) {
              <button type="button" [nxPopoverTriggerFor]="emailsListPopover" nxPopoverTrigger="click"
                class="cell-with-list-button" aria-label="Open email distribution list menu"
                (click)="onButtonClick(); $event.stopPropagation()">
                {{ application.emailDistributions[0] }}
                <span class="popover-list-trigger">
                  <span class="popover-list-trigger-counter">
                    +{{ application.emailDistributions.length - 1 }}
                  </span>
                  ▶
                </span>
              </button>

              <nx-popover #emailsListPopover direction="bottom-start" (nxOpenedChange)="onPopoverToggle($event)">
                <div>
                  <ul>
                    @for (email of application.emailDistributions; track email) {
                    <li>

                      {{ email }}
                    </li>
                    }
                  </ul>
                </div>
              </nx-popover>
              } @else if (application.emailDistributions && application.emailDistributions.length === 1) {
              <span class="cell-with-list-button">
                {{application.emailDistributions[0]}}
              </span>
              } @else {
              <span class="no-data cell-with-list-button">None</span>
              }
            </div>
          </td>
          <td nxTableCell class="td-sm">
            <div class="chip-wrapper">
              @if (application.features && application.features.length > 1) {
              <button type="button" [nxPopoverTriggerFor]="featuresListPopover" nxPopoverTrigger="click"
                class="cell-with-list-button" aria-label="Open features list menu"
                (click)="onButtonClick(); $event.stopPropagation()">
                {{ application.features[0].featureName }}
                <span class="popover-list-trigger">
                  <span class="popover-list-trigger-counter">
                    +{{ application.features.length - 1 }}
                  </span>
                  ▶
                </span>
              </button>

              <nx-popover #featuresListPopover direction="bottom-start" (nxOpenedChange)="onPopoverToggle($event)">
                <div>
                  <ul>
                    @for (feature of application.features; track feature) {
                    <li>

                      {{ feature.featureName }}
                    </li>
                    }
                  </ul>
                </div>
              </nx-popover>
              } @else if (application.features && application.features.length === 1) {
              <span class="cell-with-list-button">
                {{application.features[0].featureName}}
              </span>
              } @else {
              <span class="no-data cell-with-list-button">No features</span>
              }
            </div>
          </td>
          @if (permissionService.can_write_service_config$ | async) {
          <td nxTableCell class="actions-column">
            <button nxButton="secondary small" type="button" class="action-btn"
              (click)="onEditApplication(application); $event.stopPropagation()" title="Edit">
              Edit
            </button>
            <button nxButton="destructive small" type="button" class="action-btn delete-btn"
              (click)="onDeleteApplication(application); $event.stopPropagation()" title="Delete">
              Delete
            </button>
          </td>
          }
        </tr>
        @if (selectedApplicationId === application.applicationId) {
        <tr class="accordion-row">
          <td [attr.colspan]="(permissionService.can_write_service_config$ | async) ? 7 : 6"
            class="accordion-cell features-cell">
            <div class="features-section">
              <div class="section-header">
                <h3 class="features-title">Features</h3>
                @if (permissionService.can_write_service_config$ | async) {
                <div>
                  <button nxButton="secondary small" type="button" class="create-feature-btn"
                    (click)="onCreateFeature(application); $event.stopPropagation()" title="Add Feature">
                    Add Feature
                  </button>
                </div>
                }
              </div>

              @if (application.features.length > 0) {
              <div class="features-list">
                <table nxTable>
                  <thead>
                    <tr nxTableRow>
                      <th nxHeaderCell>Feature Name</th>
                      <th nxHeaderCell>Contact Email</th>
                      <th nxHeaderCell>Email Distributions</th>
                      @if (permissionService.can_write_service_config$ | async) {
                      <th nxHeaderCell class="actions-column">Actions</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (feature of application.features; track feature) {
                    <tr nxTableRow class="feature-row">
                      <td nxTableCell>{{ feature.featureName }}</td>
                      <td nxTableCell>{{ feature.contactEmail }}</td>
                      <td nxTableCell class="td-sm">
                        <div class="chip-wrapper">
                          @if (feature.emailDistributions && feature.emailDistributions.length > 1) {
                          <button type="button" [nxPopoverTriggerFor]="featureEmailsListPopover"
                            nxPopoverTrigger="click" class="cell-with-list-button"
                            aria-label="Open email distribution list menu"
                            (click)="onButtonClick(); $event.stopPropagation()">
                            {{ feature.emailDistributions[0] }}
                            <span class="popover-list-trigger">
                              <span class="popover-list-trigger-counter">
                                +{{ feature.emailDistributions.length - 1 }}
                              </span>
                              ▶
                            </span>
                          </button>

                          <nx-popover #featureEmailsListPopover direction="bottom-start"
                            (nxOpenedChange)="onPopoverToggle($event)">
                            <div>
                              <ul>
                                @for (email of feature.emailDistributions; track email) {
                                <li>
                                  {{ email }}
                                </li>
                                }
                              </ul>
                            </div>
                          </nx-popover>
                          } @else if (feature.emailDistributions && feature.emailDistributions.length ===
                          1)
                          {
                          <span class="cell-with-list-button">
                            {{feature.emailDistributions[0]}}
                          </span>
                          } @else {
                          <span class="no-data cell-with-list-button">None</span>
                          }
                        </div>
                      </td>
                      @if (permissionService.can_write_service_config$ | async) {
                      <td nxTableCell class="actions-column">
                        <button nxButton="secondary small" type="button" class="action-btn"
                          (click)="onEditFeature(application, feature.featureId); $event.stopPropagation()"
                          title="Edit">
                          Edit
                        </button>
                        <button nxButton="destructive small" type="button" class="action-btn delete-btn"
                          (click)="onDeleteFeature(application, feature.featureId); $event.stopPropagation()"
                          title="Delete">
                          Delete
                        </button>
                      </td>
                      }
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
              }
            </div>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
  }}

  @if (isApplicationsLoading) {
  <nx-spinner size="large"></nx-spinner>
  }
</div>